import { render, staticRenderFns } from "./toDoList.vue?vue&type=template&id=059b74b7&scoped=true&"
import script from "./toDoList.vue?vue&type=script&lang=js&"
export * from "./toDoList.vue?vue&type=script&lang=js&"
import style0 from "./toDoList.vue?vue&type=style&index=0&id=059b74b7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059b74b7",
  null
  
)

export default component.exports